module.exports = __webpack_public_path__ + "img/gy2.4689ca70.png";